import React, { useMemo } from "react";
import { NotebookPageContentBlock } from "constants/notebooks/notebook-page-content-blocks";
import { BlockRecord } from "models/view-models/block-record";
import ChecklistBlockEditor from "organisms/checklist-block-editor/checklist-block-editor";
import CodeReferenceBlockEditor from "organisms/code-reference-block-editor/code-reference-block-editor";
import { TextBlockEditor } from "organisms/notebook-text-block-rich-text-editor/text-block-editor";
import { AdditionalBlockData } from "models/interfaces/additional-block-data/additional-block-data";
import ImageBlockEditor from "organisms/image-block-editor/image-block-editor";

export interface PageBlockEditorProps {
    additionalBlockData: AdditionalBlockData;
    block: BlockRecord;
    onBlockModified: (updatedBlock: BlockRecord) => void;
    onBlockSaved: (updatedBlock: BlockRecord) => void;
    onBlockSaving: () => void;
    onDelete: (block: BlockRecord) => Promise<void>;
    onDone?: () => void;
    onMoveDown: (block: BlockRecord) => Promise<void>;
    onMoveUp: (block: BlockRecord) => Promise<void>;
}

const BLOCK_TYPE_TO_EDITOR_COMPONENT_MAP: Record<
    NotebookPageContentBlock,
    React.FC<PageBlockEditorProps>
> = {
    [NotebookPageContentBlock.Text]: TextBlockEditor,
    [NotebookPageContentBlock.CodeReference]: CodeReferenceBlockEditor,
    [NotebookPageContentBlock.Checklist]: ChecklistBlockEditor,
    [NotebookPageContentBlock.Image]: ImageBlockEditor,
};

export const PageBlockEditor: React.FC<PageBlockEditorProps> = (
    props: PageBlockEditorProps
): JSX.Element => {
    const EditorComponent = useMemo(
        () => BLOCK_TYPE_TO_EDITOR_COMPONENT_MAP[props.block.type],
        [props.block.type]
    );

    return (
        <EditorComponent
            {...props}
            additionalBlockData={props.additionalBlockData}
            onDone={props.onDone}
        />
    );
};
